import styles from '../ProductActivityPage.module.css'
import { chipLabel } from '../../lib/tagLabel'

// A Tagless harvest handover has no bucket code (the picker's tag names a
// person), so its cycle is keyed on the phone's record id. Screens call it
// "Tagless" plus the id's last characters, its random part, enough to tell one
// bucket from the next; the full id still searches and exports
// (api services/item-label.js says the same). A bin tag is named by the ID
// printed on it (VMT2, not DT32233002); its raw code still searches and exports.

export const TAGLESS_TAIL = 4

interface Named {
  item_code: string | null
  tagless?: boolean
}

export const taglessTail = (code: string) => code.slice(-TAGLESS_TAIL)

export const itemName = (c: Named): string =>
  c.tagless && c.item_code ? `Tagless · ${taglessTail(c.item_code)}` : chipLabel(c.item_code)

// What a spreadsheet gets: the whole id, said to be tagless.
export const itemExport = (c: Named): string => (c.tagless && c.item_code ? `Tagless ${c.item_code}` : c.item_code || '')

export function ItemName({ c }: { c: Named }) {
  if (!c.item_code) return null
  if (!c.tagless) {
    const label = chipLabel(c.item_code)
    return label === c.item_code ? <>{label}</> : <span title={c.item_code}>{label}</span>
  }
  return (
    <span title={`Tagless · phone record ${c.item_code}`}>
      Tagless <span className={styles.itemTail}>· {taglessTail(c.item_code)}</span>
    </span>
  )
}
